module.exports = __webpack_public_path__ + "static/img/截屏2024-08-02 17.26.45.acb3be3c.png";